import {
  Flexbox,
  ListManager,
  PageHeader,
  Paginator,
  Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterClinicalCares from '../../components/FilterClinicalCares'
import QuickFilterPeriodClinicalCares from '../../components/QuickFilterPeriodClinicalCares'
import CardHeader from '../components/CardHeader'
import CardItem from '../components/CardItem'

function ClinicalCaresByYear({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const dateRef = query?.s?.dateRef || 'createdAt'
  const { data, loading, error } = useAxiosRequest(reports.clinicalCaresByYear, query)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Atendimentos clínicos por ano"
        subtitle="Quantidade de atendimentos clínicos por ano"
        icon="fas fa-hourglass-half"
        rightAction={() => <FilterClinicalCares dateRef={dateRef} lockDateRef />}
      />
      <QuickFilterPeriodClinicalCares />
      <ListManager count={data?.count || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <>
            <Flexbox.Columns>
              <Flexbox.Column className="col-6 col-sm-12 my-2">
                <CardItem
                  header={<CardHeader title="Total de atendimentos" />}
                  item={data?.totalStatus}
                  statusList={data?.statusList}
                />
              </Flexbox.Column>
              {data?.rows?.map((item) => (
                <Flexbox.Column key={item?.year} className="col-6 col-sm-12 my-2">
                  <CardItem
                    header={<CardHeader icon="fas fa-calendar" title={item?.year} />}
                    item={item}
                    statusList={data?.statusList}
                  />
                </Flexbox.Column>
              ))}
            </Flexbox.Columns>
            <div className="my-2">
              <Paginator paginatedList={data} />
            </div>
          </>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default ClinicalCaresByYear
